import React from 'react';
import { sendStatsEvent } from '../../statistics';

/**
 * 普通文字
 * @param {*} props 
 */
export function Text(props){
  let { text, data } = props;
  if(!data){
    return null;
  };
  return(
    <div className="subfield">
      <div className="left">{text}</div>
      <div className="right">{data}</div>
    </div>
  );
}

/**
 * 电话
 * @param {*} props 
 */
export function PhoneNumber(props) {
  let { text, data } = props;
  if(!data){
    return null;
  };
  return(
    <div className="subfield" onClick={()=>{
      sendStatsEvent('poi_phone_click');
    }}>
      <div className="left">{text}</div>
      <a href={`tel:${data}`} className="right phone">{data}</a>
    </div>
  );
}

/**
 * 网站
 * @param {*} props 
 */
export function Link(props) {
  let { text, data } = props;
  if(!data){
    return null;
  };
  return(
    <div className="subfield">
      <div className="left">{text}</div>
      <a href={data} className="right link">{data}</a>
    </div>
  );
}







// WEBPACK FOOTER //
// ./src/components/Poi2/Introduction/InfoItem.js